export default __webpack_public_path__ + "static/media/logo.HV.0757ab17.png";